<template>
<div v-show="false">{{loginStatus}}</div>

<van-tabs v-show="loginResult" v-model:active="active" @click="clickTab" type="card" style="margin-top:5px">
  <van-tab title="个人业绩" v-show="state.showUserTab">
    <van-row justify="space-around" style="margin-top:20px">
      <van-col style="text-align:center">
        <div>月度</div>
        <van-circle
          v-model:current-rate="currentRate_month_user"
          :rate="(state.persondata.month_reach?state.persondata.month_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.persondata.month_reach?state.persondata.month_reach:0)+'%'"
          :stroke-width="80"
          layer-color="#ebedf0"
          color="#FFA54F"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.persondata.month_reach_total?state.persondata.month_reach_total:0}}万元</div>
        <div class="div">目标：{{state.persondata.month_goal?state.persondata.month_goal:0}}万元</div>
      </van-col>
      
      <van-col style="text-align:center">
      <div>季度</div>
      <van-circle
          v-model:current-rate="currentRate_season_user"
          :rate="(state.persondata.season_reach?state.persondata.season_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.persondata.season_reach?state.persondata.season_reach:0)+'%'"
          :stroke-width="80"
          color="#FF4500"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.persondata.season_goal_total?state.persondata.season_goal_total:0}}万元</div>
        <div class="div">目标：{{state.persondata.season_goal?state.persondata.season_goal:0}}万元</div>
      </van-col>

      <van-col style="text-align:center">
      <div>年度</div>
      <van-circle
          v-model:current-rate="currentRate_year_user"
          :rate="(state.persondata.year_reach?state.persondata.year_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.persondata.year_reach?state.persondata.year_reach:0)+'%'"
          :stroke-width="80"
          color="#CD0000"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.persondata.year_goal_total?state.persondata.year_goal_total:0}}万元</div>
        <div class="div">目标：{{state.persondata.year_goal?state.persondata.year_goal:0}}万元</div>
      </van-col>
    </van-row>
    <div style="border: 1px solid rgb(235, 225, 225);margin-top:20px"></div>

    <van-cell-group title="业绩来源">
      <van-cell title="项目/合同" value="获得业绩" />
    </van-cell-group>

    <van-collapse v-model="activeName" accordion>
      <div v-for="(person, index) in state.personlist" :key="index">
        <van-collapse-item :title="person.month_str">
            <div v-for="(detail, i) in person.itemdetail" :key="i">
              <van-cell :title="detail.itemname" :value="detail.reach_money" />
            </div>
        </van-collapse-item>
      </div>
    </van-collapse>
 
  </van-tab>
  <van-tab title="部门业绩" v-show="state.showDeptTab">
    <van-cell is-link @click="state.showPicker = true" key="部门">{{state.value}}</van-cell>
    <van-number-keyboard safe-area-inset-bottom />
    <van-popup v-model:show="state.showPicker" round position="bottom">
    <van-picker
      :columns="columns"
      @cancel="state.showPicker = false"
      @confirm="onConfirm"
      :default-index="state.selectedIndex"
    />
    </van-popup>

     <van-row justify="space-around" style="margin-top:20px">
      <van-col style="text-align:center">
        <div>月度</div>
        <van-circle
          v-model:current-rate="currentRate_month_dept"
          :rate="(state.deptdata.month_reach?state.deptdata.month_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.deptdata.month_reach?state.deptdata.month_reach:0)+'%'"
          color="#FFA54F"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.deptdata.month_reach_total?state.deptdata.month_reach_total:0}}万元</div>
        <div class="div">目标：{{state.deptdata.month_goal?state.deptdata.month_goal:0}}万元</div>
      </van-col>
      
      <van-col style="text-align:center">
      <div>季度</div>
      <van-circle
          v-model:current-rate="currentRate_season_dept"
          :rate="(state.deptdata.season_reach?state.deptdata.season_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.deptdata.season_reach?state.deptdata.season_reach:0)+'%'"
          color="#FF4500"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.deptdata.season_goal_total?state.deptdata.season_goal_total:0}}万元</div>
        <div class="div">目标：{{state.deptdata.season_goal?state.deptdata.season_goal:0}}万元</div>
      </van-col>

      <van-col style="text-align:center">
      <div>年度</div>
      <van-circle
          v-model:current-rate="currentRate_year_dept"
          :rate="(state.deptdata.year_reach?state.deptdata.year_reach:0)"
          :speed="100"
          size="80px"
          :text="(state.deptdata.year_reach?state.deptdata.year_reach:0)+'%'"
          color="#8B0000"
          layer-color="#ebedf0"
          style="margin-top: 5px;"
        />
        <div class="div">达成：{{state.deptdata.year_goal_total?state.deptdata.year_goal_total:0}}万元</div>
        <div class="div">目标：{{state.deptdata.year_goal?state.deptdata.year_goal:0}}万元</div>
      </van-col>
    </van-row>
 
    <van-cell-group>
      <van-cell title="" value="" style="color:black" />
    </van-cell-group>
 
    <div class="vant-table">
      <table cellspacing="0" :style="bgcolor" style="width:100%;" class="table">
        <tr>
          <th class="th" v-for="(item, index) in option.column" :key="index">{{ item.label }}</th>
        </tr>
        <tr v-for="(item, index) in state.deptlist" :key="index" class="list-tr" @click="openDetail(item)">
          <td v-for="(context, i) in option.column" :key="i">{{ item[context.prop] }}
          </td>
          <td><van-icon name="arrow" /></td>
        </tr>
      </table>
    </div>
  </van-tab>
</van-tabs>

</template>

<script>
import {getPersonData} from "@/http/api"; 
import {getDeptData} from "@/http/api"; 
import { createApp } from 'vue';
import { Grid, GridItem } from 'vant';
import { Icon } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Tab, Tabs } from 'vant';
import { ref } from 'vue';
import { Col, Row } from 'vant';
import { reactive } from 'vue';
import { Toast } from 'vant';
import {comdify} from "@/utils/common.js"
import {getQueryVariable} from "@/utils/common.js"
import { Picker } from 'vant';
import { Field } from 'vant';
import { Popup } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Circle } from 'vant';

const app = createApp();
app.use(Grid);
app.use(GridItem);
app.use(Icon); 
app.use(Cell);
app.use(CellGroup);
app.use(Tab);
app.use(Tabs);
app.use(Col);
app.use(Row);
app.use(Toast);
app.use(Picker);
app.use(Field);
app.use(Popup);
app.use(Collapse);
app.use(CollapseItem);
app.use(Circle);

export default {
   name: 'grid',
   setup() {
    const activeName = ref(0);
    const active = ref(0);
    const columns = [];
    const currentRate_month_user = ref(0);
    const currentRate_season_user = ref(0);
    const currentRate_year_user = ref(0);

    const currentRate_month_dept = ref(0);
    const currentRate_season_dept = ref(0);
    const currentRate_year_dept = ref(0);

    const state = reactive({
      persondata: {},
      personlist: [],
      deptdata: {},
      deptlist: [],
      loading: false,
      finished: false,
      value: '',
      showPicker: false,
      pickdata: [],
      deptid: undefined,
      selectedIndex: '0',
      showDeptTab: false,
      showUserTab: false,
    });

    const getDeptDataById = (deptid, isinit) =>{
      var userid = window.localStorage.getItem('access_userid');
      var req = JSON.stringify({'deptid': deptid, 'userid': userid});
      getDeptData(req).then(res => {
        if (res && res.data) { 
          console.log(res); 
          if(res.data.reach_detail){
            state.deptlist = [];
            res.data.reach_detail.forEach(e => {
              var obj = e;
              if(obj.month_reach){
                obj.month_reach_percent = obj.month_reach + '%';
              }
              if(obj.season_reach){
                obj.season_reach_percent = obj.season_reach + '%';
              }
              if(obj.year_reach){
                obj.year_reach_percent = obj.year_reach + '%';
              }
              if(obj.year_target){
                obj.year_reach_unit = obj.year_target + '';
              }
              
              state.deptlist.push(obj)
            });
          }
          if(res.data.org_reach){
            state.deptdata = res.data.org_reach;
          }
          
          console.log(isinit);
          if(isinit){
            if(res.data.pl_salearea){
              state.pickdata = res.data.pl_salearea;
              state.pickdata.forEach((e, index) =>{
                e.index = index;
                console.log(e.index);
                columns.push(e.orgname);
                console.log(e.orgname);

                if(index === 0){
                  state.selectedIndex = index;
                  state.value = e.orgname;
                  state.deptid = e.saleorgid;
                }

                var pdeptid = getQueryVariable("pdeptid");
                console.log(pdeptid);
                if(pdeptid && pdeptid === e.saleorgid){
                  state.selectedIndex = index;
                  state.value = e.orgname;
                  state.deptid = e.saleorgid;
                } 
              });
            } 
          }
        }else{
          //TODO
        }
        console.log('getDeptData');
      }); 
    }

    const onLoad = () => {
      console.log('onLoad');
      Toast.loading({
        message: '数据加载中...',
        forbidClick: true,
      });
      //test data
      /*
      var token = 'eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NTk1Mzc3ODYsIkxvZ2luVXNlciI6eyJhY2NvdW50SW5mb0NvZGUiOiIxMzY0ODMwMDkxNjgyNjQ4MDY0IiwiYWNjb3VudENvZGUiOiIxMzY0ODMwMDg5NDEzNTI5NjAwIiwidGVuYW50Q29kZSI6IjEwMDg0NDIiLCJwcm9kdWN0Q29kZSI6IjgzNDY4MzIyMTI0MDE4NDgzNyIsInByb2R1Y3RWZXJzaW9uQ29kZSI6IjgzNDY4NjAxNzQ2OTIwMTg1MSIsImNsaWVudFR5cGVDb2RlIjoxLCJ0b2tlbklkIjoiOGY0NDFhM2EtYjYyZC00ZWFjLWEzZDUtZDBlMjY1NTNkZjNjIiwib3JnQ29kZSI6IjEiLCJ1c2VySW5mb0lkIjoiMTM2NDgyOTcwOTA0MDQ5MDU1MyIsInVzZXJJbmZvTmFtZSI6IuS4muWKoeaVsOaNrueuoeeQhuWRmCIsInBvc2l0aW9uQ29kZSI6IjEzNjI2OTUxMDMxODA4MzY4NjQiLCJwb3NpdGlvbk5hbWUiOiLkuJrliqHnrqHnkIblkZgiLCJtZW1iZXJDb2RlIjoiMTM2NDgzMDA4OTI2MjUzNDY1NiIsInJlZlBvc2l0aW9uQ29kZSI6IjEzNDM3NzE5MjE2Nzc5NDY4ODAiLCJjYXRlZ29yeUNvZGUiOiIiLCJvcmdTdHJ1Y3RUeXBlSWQiOiIxIiwidXNlck5hbWUiOiIxMDAwMCIsInVzZXJOYW1lMSI6IjE5MDExMTEyMjIyIiwidXNlck5hbWUyIjpudWxsLCJ1c2VyTmFtZTMiOiIxMDAwMCIsInRlbmFudE5hbWUiOiLnjoTorq_kuJrnu6nnrqHnkIbns7vnu58iLCJhcHBDb2RlIjoic2FsZXMiLCJhcHBDb2RlcyI6WyJzYWxlcyJdLCJzdWJQZENvZGVzIjpbInNmYSIsImRtcyIsInBtbSIsInRwbSJdLCJjb2RlcGF0aCI6IjEuIiwiaXNsZWFmb3JnIjoiZmFsc2UiLCJtZXRhbW9kZWx0eXBlIjoyLCJpc1Ntc0xvZ2luIjpmYWxzZX19.XZFlh7V7V4LMS7IuUpsLDX6zTAUqHTRRXulgdestmDY';
      window.localStorage.setItem('access_token', token);
      window.localStorage.setItem('access_userid', '1366266179659894784');
      window.localStorage.setItem('access_username', '黄冰纯'); 
      window.localStorage.setItem('access_deptid', '1365659951124582400'); 
      window.localStorage.setItem('access_deptname', 'PeM8组');
      window.localStorage.setItem('access_powersign', 3); 
      */
      //power_sign;//1,有个人看板无团队看板;2,无个人看板有团队看板;3,有个人看板有团队看板
      var powersign = window.localStorage.getItem('access_powersign');
      console.log(powersign);
      if(powersign){
        powersign = parseInt(powersign);
        if(powersign === 1){
          state.showDeptTab = false;
          state.showUserTab = true;
        }else if(powersign === 2){
          state.showDeptTab = true;
          state.showUserTab = false;
        }else if(powersign === 3){
          state.showDeptTab = true;
          state.showUserTab = true;
        }
      }

      var userid = window.localStorage.getItem('access_userid');
      if(userid){
        var body = JSON.stringify({'userid': userid});
        getPersonData(body).then(res => {
          if (res && res.data) { 
            console.log(res); 
            if(res.data.reach_detail){
              res.data.reach_detail.forEach((e) => {
                e.itemdetail.forEach(d => {
                  d.reach_money = comdify(d.reach_money);
                });
                e.month_str = e.month+"月";
                if(e.itemdetail && e.itemdetail.length === 0){
                  e.itemdetail.push({reach_money:'无'});
                }
                state.personlist.push(e);
              });
            }
            if(res.data.person_reach){
              state.persondata = res.data.person_reach;
            }  
          }else{
            //TODO
          }
          console.log('getPersonData');
        }); 

        var pdeptid = getQueryVariable("pdeptid");
        console.log(pdeptid);
        if(pdeptid){
          getDeptDataById(pdeptid, true);
        }else{
          var deptid = window.localStorage.getItem('access_deptid');
          if(deptid){
            getDeptDataById(deptid, true);
          }
        }
      }
    }

    onLoad();

    var loginResult = false;
    return {
      active,
      state,
      loginResult,
      option: {
        column: [
          {
            label: '团队/人员',
            prop: 'dept_name'
          },
          {
            label: '年度目标(万元)',
            prop: 'year_reach_unit'
          },
          {
            label: '累计达成(元)',
            prop: 'year_reach_total'
          },
          {
            label: '月度达成率',
            prop: 'month_reach_percent'
          },
          {
            label: '季度达成率',
            prop: 'season_reach_percent'
          },
          {
            label: '年度达成率',
            prop: 'year_reach_percent'
          }
        ]
      },
      columns,
      getDeptDataById,
      activeName,
      currentRate_month_user,
      currentRate_season_user,
      currentRate_year_user,
      currentRate_month_dept,
      currentRate_season_dept,
      currentRate_year_dept,
    };
  },
  components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Icon.name]: Icon,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Col.name]: Col,
      [Row.name]: Row,
      [Toast.name]: Toast,
      [Picker.name]: Picker,
      [Field.name]: Field,
      [Popup.name]: Popup,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Circle .name]: Circle,
  },
  data() {
    return {
      loginStatus: this.getLoginStatus(),
    };
  },
  methods: {
    getLoginStatus(){
      var activeTemp = this.$route.query.active;
      console.log(activeTemp);
      if(activeTemp){
        this.active = ref(parseInt(activeTemp));
      }
      console.log('getLoginStatus');
      var token = window.localStorage.getItem('access_token');
      var username = window.localStorage.getItem('access_username');
      var msg =  "[登录失败]请联系管理员";
      if(token){
        msg = username + "[登录成功]";
        this.loginResult = true;
      }
      return msg;
    },
    openDetail(item) {
      console.log('openDetail');
      console.log(item);
      if(item){
        if(item.sign && item.dept_id){
          if(item.sign === '1'){
            this.$router.push({
              path: '/team', query:{deptid: item.dept_id, deptname: encodeURIComponent(item.dept_name), pdeptid: this.state.deptid}
            });
          }else if(item.sign === '2'){
            this.$router.push({
              path: '/person', query:{
                  userid: item.dept_id, 
                  username: encodeURIComponent(item.dept_name),
                  source: 'home',
                  pdeptid: this.state.deptid
                }
            });
          }
        }
      }
    },
    onConfirm(value) {
      console.log('onConfirm');
      this.state.value = value;
      this.state.showPicker = false;
 
      this.state.pickdata.forEach((e) =>{
        if(e.orgname === this.state.value){
          this.state.deptid = e.saleorgid;
          this.getDeptDataById(e.saleorgid, false);
        }
      });
    },
    onClickSelect() {
      console.log('onClickSelect');
      this.state.showPicker = true;
    },
    clickTab(number){
      console.log(number);
      
      //power_sign;//1,有个人看板无团队看板;2,无个人看板有团队看板;3,有个人看板有团队看板
      var powersign = window.localStorage.getItem('access_powersign');
      console.log(powersign);
      if(powersign){
        powersign = parseInt(powersign);
        if(number === 1){
          if(powersign === 1){
            this.state.showDeptTab = false;
            this.state.showUserTab = false;
          }else if(powersign === 2){
            this.state.showDeptTab = true;
            this.state.showUserTab = false;
          }else if(powersign === 3){
            this.state.showDeptTab = true;
            this.state.showUserTab = false;
          }
        }else{
          if(powersign === 1){
            this.state.showDeptTab = false;
            this.state.showUserTab = true;
          }else if(powersign === 2){
            this.state.showDeptTab = false;
            this.state.showUserTab = false;
          }else if(powersign === 3){
            this.state.showDeptTab = false;
            this.state.showUserTab = true;
          }
        }
      }
    },
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

/deep/ .van-cell__value{
  color: orange;
}

.projectname {
  color: red;
}

.vant-table {
  .table {
    border-radius: .185185rem;
    text-align: center;
    font-size: 12px;
    border-collapse:collapse ; 
    .th {
      height: 2;
      line-height: 2;
      background-color:white;
      color: gray;
      border-top-left-radius: .185185rem;
      border-top-right-radius: .185185rem;
    }
    .list-tr {
      height: 2;
      line-height: 2;
      border-spacing:0px 10px;
    }
    .list-tr:nth-child(2n) {
      background-color: white;
    }
  }

  table,table tr th, table tr td { border:1px solid rgb(216, 212, 212); }
}

.div{
  font-size:12px;
  text-align:left;
  font-weight:bold
}
</style>
